import * as React from 'react';
export const mobilepaySvg = React.forwardRef(function mobilepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.353 10.604c1.412-.428 2.606-.643 3.583-.646 1.616-.004 2.97.315 4.064.957V6.248c-1.099-.566-2.34-.868-3.725-.906a8.306 8.306 0 0 0-3.922.841v4.42Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm6.058 5.523 1.743 4.125V5.694a8.589 8.589 0 0 1 2.916-.94c1.026-.137 2.192-.115 3.499.067l-.948-2.252a8.505 8.505 0 0 0-3.925.66 9.71 9.71 0 0 0-3.285 2.294Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.343 2.597 8.658.94A1.521 1.521 0 0 0 6.676.114L1.937 2.06a1.512 1.512 0 0 0-.821 1.978l4.56 11.021a1.521 1.521 0 0 0 1.982.827l4.738-1.946a1.512 1.512 0 0 0 .821-1.978l-.565-1.366a19.157 19.157 0 0 0-.566-.027 16.163 16.163 0 0 0-.539 0l.736 1.777a.504.504 0 0 1-.274.66L7.27 14.95a.507.507 0 0 1-.66-.276L2.05 3.654a.504.504 0 0 1 .273-.66L7.062 1.05a.507.507 0 0 1 .661.275l.692 1.674c.214-.104.379-.179.494-.225l.434-.176Z',
    }),
  );
});
mobilepaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mobilepay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'mobilepay',
  svg: mobilepaySvg,
};
